import axios from '@/plugins/http/axios.js';
import config from "@/views/happiness-tips/config/happiness_tips_api.js";
import PathUri from '@/utils/path_uri';

const _pathUri = new PathUri(config.port, config.context);

export const service = {
  getHappinessTips: (idEmpresa, idUsuario, categoryId = null) => {
    let url = `${config.baseUrl + _pathUri.generateUri()}`;

    if (url.endsWith('/')) {
      url = url.slice(0, -1);
    }

    const queryParams = {};
    if (categoryId) {
      queryParams.categoryId = categoryId;
    }

    return axios({
      method: 'get',
      url: url,
      params: queryParams, // <-- Axios a�ade autom�ticamente el '?' correctamente
      headers: {
        'idEmpresa': idEmpresa,
        'idUsuario': idUsuario
      }
    });
  },
  createHappinessTip: (idEmpresa, idUsuario, formdata) => {
    return axios({
      method: 'post',
      url: `${config.baseUrl + _pathUri.generateUri()}`,
      headers: {
        'idEmpresa': idEmpresa,
        'idUsuario': idUsuario
      },
      data: formdata,
      redirect: 'follow'
    });
  },
  updateHappinessTip: (idEmpresa, idUsuario, tipId, formdata) => {
    return axios({
      method: 'put',
      url: `${config.baseUrl + _pathUri.generateUri()}/${tipId}`,
      headers: {
        'idEmpresa': idEmpresa,
        'idUsuario': idUsuario
      },
      data: formdata,
      redirect: 'follow'
    });
  },

  deleteHappinessTip: (idEmpresa, idUsuario, formData) => {
    const tipId = formData.tipId;
    console.log("? SERVICES - URL armada final:", `${config.baseUrl + _pathUri.generateUri()}/${tipId}`);

    return axios({
      method: 'delete',
      url: `${config.baseUrl + _pathUri.generateUri()}/${tipId}`,
      headers: {
        'idEmpresa': idEmpresa,
        'idUsuario': idUsuario
      },
      redirect: 'follow'
    });
  },
  deleteTip(formData) {
    const idTip = formData.idTip;

    const url = `/services/happinesslucas/core/happiness-tips/${idTip}`;

    console.log("SERVICES - URL armada final:", url);
    return axios.delete(url, { data: formData });
  }
};
